<div class="d-flex justify-content-end border-top flex-wrap">
  <span class="btn btn-sm">Actions:</span>
  @if (allowAssign()) {
    <a class="btn btn-sm btn-link"
       [routerLink]="['assign']">Assign</a>
  }

  @if (allowSpare()) {
    <a class="btn btn-sm btn-link"
       [routerLink]="['spare']">Spare</a>
  }
  @if (allowUnassign()) {
    <a class="btn btn-sm btn-link"
       [routerLink]="['unassign']">Unassign</a>
  }
  @if (allowUnavailable()) {
    <a class="btn btn-sm btn-link"
       [routerLink]="['unavailable']">Unavailable</a>
  }
  @if (notesEnabled()) {
    <a class="btn btn-sm btn-link"
       (click)="openNotes()">Notes</a>
  }
  @if (assignmentHistoryEnabled()) {
    <a class="btn btn-sm btn-link"
       (click)="openAssignmentHistory()">Assignment history</a>
  }
  <a [attr.href]="device() | mdmLink"
     class="btn btn-sm btn-link"
     target="_blank"><span i18n>View in MDM </span>
    <fa-icon [icon]="['fas', 'external-link-alt']"></fa-icon>
  </a>
</div>